$(document).ready(function() {  
  
  if ($(".product-form").length > 0) {
    $(window).scroll(function () {
      if ($(this).scrollTop() > $(".product-form").offset().top + 100) {
        $('body').addClass("sticky");
      } else {
        $('body').removeClass("sticky");
      }
    });
  }

});